<template>
  <div class="app-loading-placeholder">
    <p>Loading application...</p>
  </div>
</template>

<style scoped>
.app-loading-placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 1.2em;
  color: #777;
}
</style> 